<template>
    <div class="agent">
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)" @search-reset="searchClear"
                @row-save="handleSave" @row-update="handleUpdate" @selection-change="handleSelectionChange"
                @size-change="pageSizeChange" @current-change="pageChange">
                <template slot-scope="scope" slot="menu">
                    <el-button type="danger" size="small" plain
                        @click="edit(scope.row.id, scope.row.company)">编辑</el-button>
                    <el-button type="success" size="small" plain
                        @click.stop="handleEdit(scope.row, scope.index)">权限</el-button>
                    <!-- 材料分类查看权限 -->
                    <!-- <el-button type="warning" size="small" plain
                        @click.stop="handleMaterialPermission(scope.row, scope.index)">材料权限</el-button> -->
                </template>
                <template slot-scope="scope" slot="departIdForm">
                    <el-tree :data="selectRolePermissions" ref="tree" default-expand-all show-checkbox check-strictly
                        node-key="id"></el-tree>
                </template>
            </avue-crud>
            <el-dialog title="编辑" :visible.sync="handleEdit1" width="30%">

                <el-form status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="公司名称:" prop="company">
                        <el-input type="text" disabled v-model="form1.company"></el-input>
                    </el-form-item>
                    <el-form-item label="公司区域:" prop="address">
                        <el-input v-model="form1.address" disabled>
                        </el-input>
                        <avue-map v-model="point"></avue-map>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="detailAddress">
                        <el-input v-model="form1.detailAddress"></el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer">
                    <el-button type="primary" @click="updateAddress">确 定</el-button>
                    <el-button @click="handleEdit1 = false">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 材料权限弹出框 -->
            <el-dialog center destroy-on-close title="材料分类查看权限控制" :visible.sync="showMaterialPermissionDialog" width="30%" top="2vh" class="spec-dialog">
                <el-tree v-if="materialData" :data="materialData" show-checkbox node-key="id" ref="materialtree"></el-tree>
                <span slot="footer">
                    <el-button type="primary" @click="saveMaterialPermission">保存</el-button>
                    <el-button @click="showMaterialPermissionDialog = false">取消</el-button>
                </span>
            </el-dialog>
        </basic-container>
    </div>
</template>
  
<script>
import { agentOption } from "@/const/salesCloud/agentOption";
import {
    agentList,
    editAgent,
    findDepartmentDetail,
    getMaterialDataById,
    putMaterialDataById,
    address,
    agentAddress,
} from "@/api/salesCloud/agent";
import { getUserPermissionMenusOperation } from "@/api/salesCloud/menu";

export default {
    name: "agent",
    data() {
        return {
            tableOption: agentOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            classifySelects: [],
            currClassify: "",
            tabelObj: {},
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
            grade: {
                box: false,
                check: [],
            },
            selectRolePermissions: [],
            handleEdit1: false,
            materialData: [],
            showMaterialPermissionDialog: false,
            point: {},
            companyId: "",
            form1: {
                company: "",
                address: "",
                detailAddress: "",
            },
        };
    },
    created() {
        this.handleList();
        getUserPermissionMenusOperation().then((res) => {
            let data = JSON.parse(res.data);
            console.log(data);
            this.selectRolePermissions = data;
        });
    },
    watch: {
        point() {
            if (this.point.pname) {
                this.form1.address =
                    this.point.pname +
                    "-" +
                    this.point.cityname +
                    "-" +
                    this.point.adname;
            }
        },
    },
    mounted() { },
    computed: {
    },
    props: [],
    methods: {
        clean() {
            this.currClassify = "";
        },
        searchClear() {
            this.currClassify = "";
        },
        choseClassifyItem() {
            console.log(this.currClassify);
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            console.log(this.page);
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            agentList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                console.log(this.page);
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            agentList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            // let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            params.searchParam = params.company;
            agentList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: params.page,
                    pageSize: params.size,
                };
                this.tableLoading = false;
            });
        },
        //eslint-disable-next-line
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            console.log(page);
            agentList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            // this.clean()
            this.clean();
            this.$refs.crud.rowAdd();
        },
        handleEdit(row, index) {
            let _this = this;
            findDepartmentDetail(row.id).then((res) => {
                let page = JSON.parse(res.data);
                let data = page.rows[0];
                this.superior = {
                    id: data.superiorId,
                };
                if (null != data.dutyStuff) {
                    this.dutyStuff = {
                        id: data.dutyStuff,
                    };
                }
                _this.$refs.tree.setCheckedKeys(data.menuIds, true);
                row = data;
                console.log(data.menuIds, "data.menuIds");
                console.log("row：" + JSON.stringify(row));
            });

            this.$refs.crud.rowEdit(row, index);
        },
        transformData(data) {
            function traverse(nodes) {
                if (!nodes) {
                    return [];
                }

                return nodes.map(node => {
                    let children = node.child ? traverse(node.child) : [];
                    return {
                        label: node.fName,
                        children: children,
                        id: node.id,
                        checked: node.checked,
                    };
                });
            }
            return {
                transformedData: traverse(data),
            };
        },

        getCheckedNodes(data) {
            let checkedNodes = [];
            function traverse(node) {
                if (node.checked === 'true') {
                    checkedNodes.push(node.id);
                }
                if (node.child && node.child.length > 0) {
                    node.child.forEach(traverse);
                }
            }
            data.forEach(traverse);
            // console.log(checkedNodes);
            return checkedNodes;
        },

        async handleMaterialPermission(row) {
            this.agentId = row.id;
            const response = await getMaterialDataById(this.agentId).then((res) => {
                return JSON.parse(res.data);
            });
            let checkedNodes = this.getCheckedNodes(response);
            const { transformedData } = this.transformData(response);
            this.materialData = transformedData;
            this.showMaterialPermissionDialog = true;
            this.$nextTick(() => {
                this.$refs.materialtree.setCheckedKeys(checkedNodes);
            });
        },

        async saveMaterialPermission() {
            const checkedIds = this.$refs.materialtree.getCheckedKeys();
            const requestData = {
                rootDepartId: this.agentId,
                ids: checkedIds,
            };
            await putMaterialDataById(requestData).then((res) => {
                if (res.code === "200") {
                    this.$message({
                        showClose: true,
                        message: "保存成功",
                        type: "success",
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message ? res.message : "保存失败",
                        type: "error",
                    });
                }
            });
            this.showMaterialPermissionDialog = false;
        },
        updateAddress(row, index) {
            let data = {};
            if (this.point.location) {
                data.longitude = this.point.location.lng;
                data.latitude = this.point.location.lat;
            } else {
                this.$message({
                    showClose: true,
                    message: "请选择坐标",
                    type: "error",
                });
                done();
                return;
            }
            data.userId = this.companyId;
            console.log(this.form1.detailAddress);
            data.detailAddress = this.form1.detailAddress;
            address(data).then((res) => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                    });
                    this.handleEdit1 = false;
                    this.point = {};
                    this.form1.detailAddress = "";
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error",
                    });
                    this.point = {};
                    this.form1.detailAddress = "";
                    this.handleEdit1 = false;
                }
            });
        },

        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
            };
            this.downloadData = params;
            agentList(params).then((res) => {
                let data = JSON.parse(res.data);
                console.log(data, 11111111);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                console.log(this.page);
                this.tableLoading = false;
            });
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         *
         **/
        handleSave(row, done) {
            row.rootId = this.currClassify;
            console.log(row);
            addSystemClassify(row).then((res) => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "新增成功",
                        type: "success",
                    });
                    done();
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error",
                    });
                    done();
                }
            });
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange() {
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            console.log(row);
            delSystemClassify(row.id).then((res) => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "删除成功",
                        type: "success",
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error",
                    });
                }
            });
        },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         *
         **/
        handleUpdate(row, index, done) {
            console.log(row.id);
            let params = {};
            params.departId = row.id;
            console.log(this);
            let checkKeys = [].concat(
                this.$refs.tree.getHalfCheckedKeys(),
                this.$refs.tree.getCheckedKeys()
            );
            params.menuIds = checkKeys;
            editAgent(params).then((res) => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                    });
                    done();
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error",
                    });
                    done();
                }
            });

            address(params).then((res) => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                    });
                    done();
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error",
                    });
                    done();
                }
            });
        },

        edit(companyId, companyName) {
            this.point = {};
            this.form1.detailAddress = "";
            this.form1.company = "";
            this.form1.address = "";
            this.handleEdit1 = true;
            this.companyId = companyId;
            console.log(this.point, "11111111333333111");
            agentAddress(companyId).then((res) => {
                if (res.data) {
                    let data = JSON.parse(res.data);
                    this.form1.company = data.company;
                    this.form1.address = data.address;
                    this.form1.detailAddress = data.detailAddress;
                    let location = {};
                    location.lng = data.longitude;
                    location.lat = data.latitude;
                    this.point.location = location;
                    this.point.pname = data.province;
                    this.point.cityname = data.city;
                    this.point.adname = data.area;
                    console.log(this.point, "11111111111");
                } else {
                    this.form1.company = companyName;
                }
            });
        },
    },
};
</script>
  
<style lang="scss" scoped>
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.el-input__inner {
    width: 70%;
}

.agent .avue-map {
    position: absolute;
    right: 10px;
    top: 0;
}

.spec-dialog .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(100vh - 140px);
}
</style>
  